import React from "react"

import { AppMileageAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { mileage } from "@signals"


export default function MileageAutocomplete({ ...props }) {
    return <AppMileageAutocomplete
		value={mileage.value}
		onChange={e => mileage.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/mileages`}
		{...props}
	/>
}